import React from 'react';

import Classes from './Skeleton.module.scss';

type TProps = React.HTMLAttributes<HTMLElement> & {
  withAnimation?: boolean;
  width?: string;
  height?: string;
  as?: string;
};

const SkeletonBase = ({
  width = '',
  height = '',
  className = '',
  style = {},
  as = 'div',
  withAnimation = true,
  ...rest
}: TProps) => {
  const styles = {
    ...style,
    ...(width ? { width } : {}),
    ...(height ? { height } : {}),
  };

  const As = (as || 'div') as React.ElementType;
  return (
    <As
      {...rest}
      className={`${Classes.BaseSkeleton} ${className} ${withAnimation ? Classes.withAnimation : ''}`}
      style={styles}
    />
  );
};

export default SkeletonBase;
